import React from 'react';
import PropTypes from 'prop-types'
import { ButtonLink } from '../buttonLink/ButtonLink';
import getLocaleMessages from '../../utils/localesMessages';

const {
	navigationHeader
} = getLocaleMessages('buttons/common');

export const NavigationHeader = ({ headerContent, isMobile }) => {
	return (
		<div className="nav-header-container">
			<h1 className="vx_text-2 inline">{headerContent}</h1>
			<div className="inline new-button-container">
				<ButtonLink text={navigationHeader.newButton} href="/buttons" />
			</div>

			{!isMobile &&
				<hr className="vx_hr nav-header-hr" />
			}
		</div>
	)
}

NavigationHeader.propTypes = {
	headerContent: PropTypes.string,
	isMobile: PropTypes.bool
}



// WEBPACK FOOTER //
// ./buttons/components/navigationHeader/NavigationHeader.js